module.exports = __webpack_public_path__ + "static/media/mcculla.04e1d841.jpg";